module.exports = __webpack_public_path__ + "48679792e0b5507bd1b1c6038250d561.svg";